export const getMinBreakPoint = (brp: string) => `calc(${brp} + 1px)`
